import { z } from 'zod'

/**
 * The approvals screen keeps its active section in the URL, the same way the customer file does.
 *
 * The reason this matters here specifically: the dual-control outcome notice — "sent for approval
 * — nothing has changed yet", shown right after a maker submits something — links straight to
 * `/approvals?tab=mine`. That link is only worth anything if the screen actually opens on the
 * maker's own submissions rather than on the checker's queue, which is what `validateSearch` wires
 * up. A hand-edited or stale value degrades to the queue tab rather than throwing.
 */

export const APPROVALS_TABS = ['queue', 'mine', 'lookup'] as const

export type ApprovalsTab = (typeof APPROVALS_TABS)[number]

export const approvalsSearchSchema = z.object({
  tab: z.enum(APPROVALS_TABS).optional().catch(undefined),
})
